import { type RouteProps, matchPath } from 'react-router-dom';

import type { BreadcrumbItem } from 'components/ui';

export const getBreadcrumbTitle = (items?: BreadcrumbItem[], loading?: boolean) =>
  items
    ?.map((i) => i.title?.toString().trim())
    .filter((t) => t && !(loading && t.includes('undefined')))
    .join(' / ') || undefined;

interface GetFallbackRedirectPathArgs {
  pathname: string;
  routes: RouteProps<string>[];
}

/**
 * Tab routes render without a `Switch`, so a url matching no tab renders an empty body — reachable
 * whenever a tab is gated off and a bookmark to it survives. Falls back to the default (first) tab,
 * only when its path is a resolved prefix of the url, leaving other pages untouched.
 */
export const getFallbackRedirectPath = ({
  pathname,
  routes,
}: GetFallbackRedirectPathArgs): string | undefined => {
  const defaultPath = routes[0]?.path;

  if (typeof defaultPath !== 'string' || defaultPath.includes(':')) {
    return undefined;
  }

  if (!pathname.startsWith(`${defaultPath}/`)) {
    return undefined;
  }

  const isMatched = routes.some(({ path, exact, strict, sensitive }) =>
    matchPath(pathname, { path, exact, strict, sensitive })
  );

  return isMatched ? undefined : defaultPath;
};
